import Map from 'ol/Map';
import React from 'react';
import { Projection } from 'ol/proj';
import View from 'ol/View';
import { getCenter } from 'ol/extent';
import { Zoom } from 'ol/control';

const extent = [0, 0, 1200, 680];
const projection = new Projection({
  code: 'xkcd-image',
  units: 'pixels',
  extent: extent
});

export const MapIllustrationContext = React.createContext<Map>(
  new Map({
    layers: [],
    target: 'map',
    controls: [new Zoom()],
    view: new View({
      projection: projection,
      center: getCenter(extent),
      resolution: 0.8,
      zoom: 5,
      maxZoom: 8
    })
  })
);
